import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import JobType from './jobType';
import JobDetailEdit from './jobDetailEdit';
import TaskDetailEdit from './taskDetailEdit';

class JobNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(),
      page: JobHelper.PageConstants.JOB_TYPE,
      isChanged: false,
      taskIndex: null, // Current task index that's being edited
      error: {}, // Used for job detail form
    };
    this.onFormChange = this._onFormChange.bind(this);
    this.setPage = (page) => { this.setState({ page }); };
    this.setTaskIndex = (taskIndex) => { this.setState({ taskIndex }); };
    this.save = this._save.bind(this);
  }

  _getDefaultForm = () => ({
    base_task_attributes: {
      address_attributes: {
        name: null,
        line_1: null,
        line_2: null,
        country: null,
        zip: null,
        contact_person: null,
        contact_number: null,
        email: null,
      },
      time_type: null,
      time_from: null,
      time_window_id: null,
    },
    tag_list: [],
    remarks: null,
    attachments_attributes: [],
    tasks_attributes: [],
  });

  _onFormChange(fieldName, value, index, isDelete) {
    if (fieldName === 'tasks_attributes' && Utils.Helper.isNullOrUndefined(index)) {
      // Special behavior for tasks attributes, this is not a general behaviour
      this.setState((prevState) => {
        const form = { ...prevState.form };
        form.tasks_attributes.push(value);

        return { form, isChanged: true };
      });
    } else if (fieldName === 'base_task_attributes.billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: true,
      }));
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: true,
      }));
    }
  }

  _save() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.form.saving);

    let form = this.state.form;
    if (this.state.form.job_type === 'p2p') {
      form = {
        ...this.state.form,
        job_type: 'delivery',
        tag_list: this.state.form.tag_list.concat(['Point-to-Point']),
      };
    }

    this.props.dispatch(ReduxActions.job.create(form))
      .then((result) => {
        Utils.Router.transitionTo(`/submissions/jobs/${result.job.id}`);
      })
      .catch((error) => {
        this.setState({ error });
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  render() {
    const { page, form, taskIndex } = this.state;

    switch (page) {
      case JobHelper.PageConstants.JOB_TYPE:
        return (
          <JobType
            onFormChange={this.onFormChange}
            setPage={this.setPage}
          />
        );
      case JobHelper.PageConstants.JOB_DETAIL_EDIT:
        return (
          <JobDetailEdit
            error={this.state.error}
            form={form}
            isChanged={this.state.isChanged}
            onFormChange={this.onFormChange}
            save={this.save}
            setPage={this.setPage}
            setTaskIndex={this.setTaskIndex}
          />
        );
      case JobHelper.PageConstants.TASK_DETAIL_EDIT:
        return (
          <TaskDetailEdit
            form={form.tasks_attributes[taskIndex] || {}}
            index={taskIndex}
            jobType={this.state.form.job_type}
            onFormChange={this.onFormChange}
            setPage={this.setPage}
            time={{
              time_from: form.base_task_attributes.time_from,
              time_to: form.base_task_attributes.time_to,
              time_type: form.base_task_attributes.time_type,
              time_window_id: form.base_task_attributes.time_window_id,
            }}
          />
        );
      default:
        return false;
    }
  }
}

JobNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        saving: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default connect()(translate('')(JobNew));
